// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable babel/camelcase, init-declarations, no-param-reassign, prefer-named-capture-group, no-console, default-param-last */
import Cookies from "js-cookie" // debug cookies
import * as R from "ramda"
// @ts-expect-error: Flow to TS migration.
import queryString from "query-string"
import * as cookies from "@kiwicom/cookies"
import { Cookie, load } from "@kiwicom/cookies"
import { ClientEvent, make as makeEvent } from "@kiwicom/nitro/lib/records/Event"
import type { EventPayload, Event, Props } from "@kiwicom/nitro/lib/records/Event"
// @ts-expect-error: Flow to TS migration.
import { make as makeDataEvent, EventType, EventData } from "@kiwicom/nitro/lib/records/DataEvent"
import * as logger from "@kiwicom/nitro/lib/services/log/logger"
// @ts-expect-error: Flow to TS migration.
import parser from "ua-parser-js"

import session from "../../browser/session"
import { get, getOr } from "../../utils/get"
import has from "../../utils/has"
import * as perfTracker from "../../utils/perfTracker"
import { getBidFromUrl } from "../url/getBidFromUrl"
import { cuckooEvents } from "../../consts/enums"
import constants from "../../consts/config"
import * as utm from "../../../../app/scripts/tools/utm"
import { getLanguageInfo } from "../staticData"
import type { LanguageInfo } from "../../records/LanguageInfo"
import { getQueryParams } from "../url/urlBuilders"
import parseCookie from "../utils/parseCookie"
import type { CuckooEvent } from "../../consts/enums"
import { getAffilId as getAffilIdSelector } from "../options/selectors"
import * as exponeaEvents from "../../modules/Exponea/events"
import { TrackingModule } from "@kiwicom/frontend-mmb/services/tracking/constants/trackingEventTypes"
import { Platform } from "@kiwicom/nitro/lib/services/platform/consts"
import { getPlatform as getNitroPlatform } from "@kiwicom/nitro/lib/services/platform/shared"
import { ParsedUrlQuery } from "querystring"
import { isLoggedIn } from "@kiwicom/nitro/lib/services/auth"

type Level = "critical" | "error" | "warning" | "track" | "log" | "info"
export type EventProps =
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  | {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any
    }
  | undefined
const IGNORED_FIELDS = ["errorType", "detail"]

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CuckooTrackOptions = Record<any, any>

const noop = () => {}

function getBid(): number | null | undefined {
  // @ts-expect-error: Flow to TS migration.
  if (window.SP_GLOBALS.SKYPICKER_MODULE === "mmb") {
    const bidFromUrl = getBidFromUrl(window.location.pathname)
    return bidFromUrl ? Number(bidFromUrl) : undefined
  }
  const query = queryString.parse(window.location.search)
  return Number(query.bid) || undefined
}

const getTrackName = (
  event: CuckooEvent | (ClientEvent<TrackingModule> & { detail?: never }),
): string => [event.category, event.action, event.detail].filter(Boolean).join(": ")

const UA_WEBVIEW_MARKER_ANDROID = "kiwi_android"
const UA_WEBVIEW_MARKER_IOS = "kiwi_ios"

function getPlatformFromUserAgent(): Platform.ANDROID | Platform.IOS | null {
  if (typeof window === "undefined") {
    return null
  }
  const { userAgent } = window.navigator
  const isAndroidWebviewUserAgent = userAgent.includes(UA_WEBVIEW_MARKER_ANDROID)
  const isiOSWebviewUserAgent = userAgent.includes(UA_WEBVIEW_MARKER_IOS)
  if (isAndroidWebviewUserAgent) {
    return Platform.ANDROID
  }
  if (isiOSWebviewUserAgent) {
    return Platform.IOS
  }
  return null
}

function getPlatformFromQuery(
  query: ParsedUrlQuery,
): Platform.ANDROID | Platform.IOS | Platform.WEB {
  const { platform } = query
  if (platform && [Platform.ANDROID, Platform.IOS].includes(platform as Platform)) {
    return platform as Platform.ANDROID | Platform.IOS
  }
  return Platform.WEB
}

/**
 * Helper function for obtaining platform.
 *
 * Determines platform value with following precedence:
 * 1. based on UI cookie value
 * 2. based on user agent
 * 3. based on query parameter
 * 4. defaults to web platform
 *
 * @param queryParams
 * @returns platform if it is android webview, ios webview, tequila iframe, or regular web
 */
export function getPlatform(queryParams: Record<string, string>): Platform {
  const uiCookie = load(Cookie.UI)
  const platform = getNitroPlatform({ ui: uiCookie })

  if ([Platform.ANDROID, Platform.IOS, Platform.TEQUILA].includes(platform)) {
    return platform
  }

  return getPlatformFromUserAgent() ?? getPlatformFromQuery(queryParams)
}

// Can be updated when the user logs in
const getAffilID = (): string => {
  try {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const cookiesAffilId = cookies.load(Cookie.AFFILIATE_ID) || ""
    if (cookiesAffilId) {
      return cookiesAffilId
    }

    if (typeof window === "undefined") {
      return ""
    }

    // @ts-expect-error: Flow to TS migration.
    return getAffilIdSelector(window.reduxStore.getState()) || ""
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    return ""
  }
}

const getState = () => {
  try {
    // @ts-expect-error: Flow to TS migration.
    return window.reduxStore.getState()
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    return {}
  }
}

/**
 * Inspired by https://segment.com/docs/libraries/analytics.js/#track
 * @param event eg. "Booking finished", supports » to divide "category » action"
 * @param properties e.g. { logstash: {...}, ga: {label: "...", value: "..."} }
 */
class Cuckoo {
  userId: string | null | undefined

  fake: boolean

  enabled: boolean

  // @ts-expect-error: Flow to TS migration.
  deeplinkId: string

  // @ts-expect-error: Flow to TS migration.
  sessionId: string

  // @ts-expect-error: Flow to TS migration.
  pageViewId: string

  // @ts-expect-error: Flow to TS migration.
  affilId: string

  // @ts-expect-error: Flow to TS migration.
  ip: string

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  affilParams: {
    [key: string]: string
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  UTMs: {
    [key: string]: string
  }

  // @ts-expect-error: Flow to TS migration.
  pageName: string

  // @ts-expect-error: Flow to TS migration.
  module: string

  // @ts-expect-error: Flow to TS migration.
  host: string

  // @ts-expect-error: Flow to TS migration.
  brandingId: string

  // @ts-expect-error: Flow to TS migration.
  langInfo: LanguageInfo

  // @ts-expect-error: Flow to TS migration.
  langId: string

  USE_XHR: boolean

  bid: number | null | undefined

  bufferLogLady: EventPayload[] = []

  constructor() {
    // will send all logs to console
    this.fake = false

    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (typeof window !== "undefined" && window.SP_GLOBALS) {
      const { userAgent } = window.navigator
      const parsedAgent = parser(userAgent)
      const queryParams = getQueryParams()

      this.enabled = true
      this.fake = Cookies.get("debug_fakeCuckoo") === "true"
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      this.deeplinkId = session.deeplinkId || ""
      this.sessionId = session.sessionId
      this.pageViewId = session.pageViewId
      this.affilId = getAffilID()
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      this.affilParams = session.affiliate?.params || {}
      this.UTMs = session.UTMs
      // @ts-expect-error: Flow to TS migration.
      this.pageName = window.SP_GLOBALS.SKYPICKER_PAGE_NAME || window.SP_GLOBALS.SKYPICKER_PAGE
      // @ts-expect-error: Flow to TS migration.
      this.module = window.SP_GLOBALS.SKYPICKER_MODULE
      this.host = window.location.host
      // @ts-expect-error: Flow to TS migration.
      this.brandingId = window.__INITIAL_STATE__.options.branding.id
      // @ts-expect-error: Flow to TS migration.
      this.langInfo = getLanguageInfo(window.__INITIAL_STATE__)
      this.bid = getBid()
      // @ts-expect-error: Flow to TS migration.
      this.ip = window.SP_GLOBALS.IP

      logger.init({
        project: "frontend/frontend",
        module: this.module,
        // @ts-expect-error: Flow to TS migration.
        moduleVersion: window.SP_GLOBALS.RELEASE_INFO.commit_hash,
        pageName: this.pageName,
        langId: this.langInfo.id,
        pageViewId: this.pageViewId,
        brandingId: this.brandingId,
        affilParams: this.affilParams,
        ip: this.ip,
        // Remove FlowFixMe once this is solved https://go.kiwi.com/MNHERS_F8
        // @ts-expect-error: Flow to TS migration.
        bid: this.bid,
        splitster: getOr({}, ["__INITIAL_STATE__", "splitster"], window),
        UTMs: this.UTMs,
        // @ts-expect-error: Flow to TS migration.
        features: window.__DARWIN__.features,
        // User Agent - Info
        device: parsedAgent.device.model || "",
        browser: parsedAgent.browser.name || "",
        os: parsedAgent.os.name || "",
        browserVersion: parsedAgent.browser.version || "",
        osVersion: parsedAgent.os.version || "",
        platform: getPlatform(queryParams),
        source: queryParams.source || "",
      })

      // Sends buffered LL every second
      setInterval(this.flushLogLady, 1000)

      // Flush buffer before closing the window
      window.addEventListener("beforeunload", this.flushLogLady)
    } else {
      // Disable on server
      this.enabled = false
    }

    // http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/ &
    // https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
    this.USE_XHR =
      typeof window !== "undefined" &&
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      window.XMLHttpRequest &&
      "withCredentials" in new XMLHttpRequest()

    // SetUp Infinario Timezone
    if (typeof window !== "undefined" && has("infinario", window)) {
      const timezone = -new Date().getTimezoneOffset() / 60
      // @ts-expect-error: Flow to TS migration.
      window.infinario.update({ timezone_vs_UTC: timezone })
    }
  }

  setBid = (bid: number) => {
    this.bid = bid

    logger.init({
      bid,
    })
  }

  // export getTrackName function in the cuckoo object
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/member-ordering
  getTrackName = getTrackName

  // Control
  // ===
  disable() {
    this.enabled = false
  }

  enable() {
    this.enabled = true
  }

  identify(userId: string) {
    this.userId = userId
  }

  maybeSend(
    level: Level,
    ev: CuckooEvent | ClientEvent<TrackingModule> | string,
    props: EventProps,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    options: CuckooTrackOptions = {},
    callback: (() => void) | null = null,
  ) {
    if (this.enabled) {
      let evString

      if (typeof ev === "object") {
        evString = this.getTrackName(ev)
      } else {
        evString = ev
      }

      // Avoid circular references errors in Error object
      // Fix of incompatibility in other browsers than Safari (err objects in logs)
      if (props && get("err", props) && props.err instanceof Error) {
        props.err = {
          message: get(["err", "message"], props),
          stack: get(["err", "stack"], props),
        }
      }

      // detail was removed from DD logs on 6.6.2024, so passing it as a prop now
      // @ts-expect-error: Nitro's ClientEvent type doesn't contain detail
      const detail = ev.detail ?? undefined
      if (detail) {
        props = props ? { ...props, detail } : { detail }
      }

      if (typeof ev === "object") {
        if (ev.errorType) props = { ...props, errorType: ev.errorType }
        // track logLady only for enums style tracking, ignore track middleware
        // Fix this the next time the file is edited. (Flow to TS)
        // @ts-expect-error: Flow to TS migration.
        this.trackLogLady(level, R.omit(IGNORED_FIELDS, ev), props ?? {}, callback)
      }
      switch (level) {
        case "info":
          this.printToConsole("logstash", evString, props)
          break
        case "track":
        case "log":
          if (props) {
            this.gtmDeprecated(evString, props)
          }
          if (typeof ev !== "object" || ev.destinations?.logmole) {
            this.send(evString, props)
          }
          break
        case "warning":
          this.send(`[warning] ${evString}`, props)
          break
        case "error":
          this.send(`[error] ${evString}`, props)
          break
        case "critical":
          this.send(`[critical] ${evString}`, props)
          break
        default:
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          throw new Error(`Cuckoo unsupported log level: ${level}`)
      }

      if (this.fake) {
        this.printToConsole(level, evString, props)
      }
    }
  }

  trackLogLady(
    level: Level,
    event: Event,
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
    data: {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      [key: string]: any
    },
    callback: (() => void) | null = null,
  ) {
    if (this.fake) return
    if (callback) {
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      logger.log(event, data).catch(noop).then(callback)
      return
    }

    // FIXME: a method has been detected that possibly mutates the object, consider a more
    // functional approach (Ramda might help)

    this.bufferLogLady.push(makeEvent(event, data))
  }

  flushLogLady = () => {
    if (this.bufferLogLady.length > 0) {
      logger.batch(this.bufferLogLady).catch(noop)

      this.bufferLogLady = []
    }
  }

  // Decorators for tracking various log levels
  // ===
  info(ev: CuckooEvent, props: EventProps) {
    this.maybeSend("info", ev, props)
  }

  log(ev: CuckooEvent, props: EventProps) {
    this.maybeSend("log", ev, props)
  }

  track(
    ev: CuckooEvent | ClientEvent<TrackingModule> | string,
    props: EventProps,
    options: CuckooTrackOptions = {},
  ) {
    this.maybeSend("track", ev, props, options)
  }

  promiseTrack = (
    ev: CuckooEvent | string,
    props: EventProps,
    options: CuckooTrackOptions = {},
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    timeout: number = 2000,
  ): Promise<void> =>
    new Promise((resolve: (result: Promise<undefined> | undefined) => void) => {
      setTimeout(resolve, timeout)
      // @ts-expect-error: Flow to TS migration.
      this.maybeSend("track", ev, props, options, resolve)
    })

  warning(ev: CuckooEvent, props: EventProps, options: CuckooTrackOptions = {}) {
    this.maybeSend("warning", ev, props, options)
  }

  error(ev: CuckooEvent, props: EventProps) {
    this.maybeSend("error", ev, props)
  }

  critical(ev: CuckooEvent, props: EventProps, options: CuckooTrackOptions = {}) {
    this.maybeSend("critical", ev, props, options)
  }

  nitro(ev: EventPayload, props: Props) {
    this.maybeSend("track", ev, props)
  }

  ga(category: string, action: string, label?: string | null, value?: string | null) {
    // @ts-expect-error: Flow to TS migration.
    if (this.enabled && !this.fake && window.ga) {
      // @ts-expect-error: Flow to TS migration.
      window.ga("send", "event", category, action, label, value)
    } else {
      this.printToConsole(
        "ga",
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        `category: ${category}, action: ${action}, label: ${label || ""}, value: ${value || ""}`,
      )
    }
  }

  gaIdentify(userId: string) {
    // @ts-expect-error: Flow to TS migration.
    if (this.enabled && !this.fake && window.ga) {
      // @ts-expect-error: Flow to TS migration.
      window.ga("set", "userId", userId)
    }
  }

  gaPageView() {
    // @ts-expect-error: Flow to TS migration.
    if (this.enabled && !this.fake && window.ga) {
      // @ts-expect-error: Flow to TS migration.
      window.ga("send", "pageview")
    } else {
      this.printToConsole("ga", "pageview")
    }
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gtmDeprecated(event: string, payload: any) {
    new Promise(
      (
        resolve: (result: Promise<undefined> | undefined) => void,
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject: (error?: any) => void,
      ) => {
        const timeFromPageLoad = perfTracker.getTimeFromPageLoad()

        // @ts-expect-error: Flow to TS migration.
        if (this.enabled && !this.fake && window.dataLayer && !window.SP_GLOBALS.IS_STAGING) {
          setTimeout(reject, 1000)
          // FIXME: a method has been detected that possibly mutates the object, consider a more
          // functional approach (Ramda might help)

          // @ts-expect-error: Flow to TS migration.
          window.dataLayer.push({
            event,
            affilId: getAffilID(),
            ...payload,
            timeFromPageLoad,
            eventCallback: resolve,
          })
        } else {
          this.printToConsole("gtm", event, { ...payload, timeFromPageLoad })
          // @ts-expect-error: Flow to TS migration.
          resolve()
        }
      },
    ).catch((error) => {
      this.warning(cuckooEvents.GENERAL_TRACKING_FAILED, {
        service: "DataLayer",
        error,
      })
    })
  }

  // new GTM tracking - both version needed until integration is done
  gtm(eventType: EventType, action: string, data: EventData) {
    try {
      const event = makeDataEvent({ type: eventType, action, data })
      // @ts-expect-error: Flow to TS migration.
      if (this.enabled && !this.fake && window.dataLayer && !window.SP_GLOBALS.IS_STAGING) {
        // @ts-expect-error: Flow to TS migration.
        window.dataLayer.push({
          ...event,
          trackingData: { ...event.trackingData, affilId: getAffilID(), bid: getBid() },
        })
      } else {
        this.printToConsole("gtm", eventType, event)
      }
    } catch (error) {
      this.warning(cuckooEvents.GENERAL_TRACKING_FAILED, {
        service: "DataLayer",
        error,
      })
    }
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-inferrable-types
  async infinario(ev: CuckooEvent, data: any = {}, includeSplitster: boolean = false) {
    const event = ev.action
    // @ts-expect-error: Flow to TS migration.
    if (this.enabled && !this.fake && window.infinario) {
      try {
        if (event === exponeaEvents.EXPONEA_IDENTIFY.action) {
          // @ts-expect-error: Flow to TS migration.
          window.infinario.identify({
            email_id: data.toLowerCase().trim(),
            // Fix this the next time the file is edited. (Flow to TS)
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            user_id: cookies.load(Cookie.USER_ID) || "",
          })
          // @ts-expect-error: Flow to TS migration.
          window.infinario.update({ email: data.toLowerCase().trim() })
        } else if (event === exponeaEvents.EXPONEA_PAGE_LOADED.action) {
          // @ts-expect-error: Flow to TS migration.
          window.infinario.update({
            language: this.langInfo.hreflang.split("-")[0],
            languageISO: this.langInfo.hreflang,
          })
        } else {
          // Fix this the next time the file is edited. (Flow to TS)
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          if (has("data.email", data)) {
            data.email = data.email.toLowerCase()
          }

          const clientTimestamp = new Date().toISOString() // TODO for Exponea SDK to LL migration, remove when done
          const payload = {
            ...data,
            affilId: getAffilID(),
            langId: this.langInfo.hreflang, // hreflang from spreadsheet (because it will be clear in ISO 639 format)
            pageName: this.pageName,
            isLoggedIn: await isLoggedIn(),
            // Fix this the next time the file is edited. (Flow to TS)
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            visitorId: cookies.load(Cookie.USER_ID) || "",
            // Fix this the next time the file is edited. (Flow to TS)
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            exponeaCookie: cookies.load("__inf_etc__") || "",
            module: this.module,
            bid: this.bid,
            email_id:
              data.email_id ||
              // @ts-expect-error: Flow to TS migration.
              (window.reduxStore && R.toLower(getOr("", ["user", "user", "email"], getState()))),
            cookiePolice: parseCookie(cookies.load("__kwc_settings") ?? ""),
            // rename keys to camelCase (utm_source -> utmSource)
            // @ts-expect-error: Flow to TS migration.
            ...R.pipe(
              R.toPairs,
              // Fix this the next time the file is edited. (Flow to TS)
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              R.map(([key, value]: [any, any]) => [
                // @ts-expect-error: Flow to TS migration.
                key.replace(/(_[a-z])/g, (s) => s[1].toUpperCase()),
                value,
              ]),
              // @ts-expect-error: Flow to TS migration.
              R.fromPairs,
            )(utm.loadFromSession(this)),
            ...(includeSplitster ? getOr({}, ["__INITIAL_STATE__", "splitster"], window) : {}),
            clientTimestamp,
          } as const
          this.track(ev, payload)

          if (event === exponeaEvents.EXPONEA_SUBSCRIPTION.action) {
            // @ts-expect-error: Flow to TS migration.
            window.infinario.update({ email: data.email.toLowerCase().trim() })

            // we want to subscribe for notifications as well
            // @ts-expect-error: Flow to TS migration.
            if (window.infinario.notifications.isAvailable()) {
              // @ts-expect-error: Flow to TS migration.
              window.infinario.notifications.isSubscribed(
                // @ts-expect-error: Flow to TS migration.
                (subscriptionActive, notificationsDenied) => {
                  if (!subscriptionActive && !notificationsDenied)
                    // @ts-expect-error: Flow to TS migration.
                    window.infinario.notifications.subscribe()
                },
              )
            }
          }
        }
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } catch (err: any) {
        console.error(err)
      }
    } else {
      this.printToConsole("infinario", event, data)
    }
  }

  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  screenRecording(event: string, data: any) {
    if (this.enabled && !this.fake) {
      // @ts-expect-error: Flow to TS migration.
      if (window.FS) {
        // stringified data, type must be suffix of the name
        // https://help.fullstory.com/develop-js/setuservars
        // @ts-expect-error: Flow to TS migration.
        window.FS.setUserVars({ [`${event}_str`]: data })
      }
      // @ts-expect-error: Flow to TS migration.
      if (!window.FS) {
        this.printToConsole("screen recording attributes sending failed", event, data)
      }
    }
  }

  send(ev: string, raw: EventProps = {}) {
    const addedProps = R.pickBy(Boolean, {
      "@session": this.sessionId,
      "@deeplinkId": this.deeplinkId,
      "@timestamp": new Date().toISOString(),
      "@pageViewId": this.pageViewId,
      "@pageName": this.pageName,
      "@module": this.module,
      "@host": this.host,
      "@brand": this.brandingId,
      "@bid": this.bid,
    })

    // @ts-expect-error: Flow to TS migration.
    const props = { ...raw, ...addedProps } as const

    if (typeof window !== "undefined") {
      // TODO: make it work for Node
      if (this.USE_XHR) {
        const req = new XMLHttpRequest()
        // @ts-expect-error: Flow to TS migration.
        if (!__DEV__) {
          req.onreadystatechange = () => {
            // 4 means request is in done state
            // req.status === 0 was probably blocked by ad blocker
            if (req.readyState === 4 && req.status !== 200 && req.status !== 0) {
              // TODO: Add winston logging for error tracking (Datadog integration)
              console.error("Logmole request failed", {
                status: req.status,
                response: req.response,
              })
            }
          }
        }
        req.open("POST", `${constants.logstashApiUrl}`, true)
        req.withCredentials = false // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
        req.setRequestHeader("Content-type", "text/plain") // Actually JSON, but need to be set to plain to avoid OPTIONS request
        req.send(
          JSON.stringify({
            userId: this.userId,
            event: ev,
            properties: props,
            source: "frontend",
          }),
        )
      }
    }
  }

  printToConsole(
    target: string | null | undefined = "cuckoo",
    ev: string,
    rawProps: EventProps = {},
  ) {
    const globals = R.pickBy(Boolean, {
      "@session": this.sessionId,
      "@deeplinkId": this.deeplinkId,
      "@timestamp": new Date().toISOString(),
      "@pageViewId": this.pageViewId,
      "@pageName": this.pageName,
      "@module": this.module,
      "@host": this.host,
      "@brand": this.brandingId,
      "@bid": this.bid,
    })

    const props = { ...rawProps, globals } as const

    let color
    switch (target) {
      case "infinario":
        color = "#8763FE"
        break
      case "track":
        color = "#106FC4"
        break
      case "ga":
        color = "#EE5A30"
        break
      case "gtm":
        color = "#E683EC"
        break
      default:
        color = "#38425D"
    }

    if (Cookies.get("showConsoleLogs") === "true") {
      console.info(
        // @ts-expect-error: Flow to TS migration.
        `%c${target.toUpperCase()}`,
        `padding: 0 5px; background-color: ${color}; color: white;`,
        ev,
        props,
      )
    }
  }
}

export default new Cuckoo()
